import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { X } from '@finect/tabular-icons/x';
var DeleteButton = styled.button.withConfig({
  displayName: "DeleteContent__DeleteButton",
  componentId: "sc-hxvimc-0"
})(["position:absolute;top:3px;right:-6px;cursor:pointer;color:", ";&:hover{color:", ";}", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.fontLL;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.negative;
}, maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    top: 5px;\n    right: -2px;\n  "]))));
export var DeleteContent = function DeleteContent(_ref3) {
  var handleClick = _ref3.handleClick;
  return React.createElement(DeleteButton, {
    onClick: handleClick,
    title: "Eliminar"
  }, React.createElement(X, {
    size: "16",
    strokeWidth: "3"
  }));
};